<template>
  <div class="personal-data-full-width">
    <div class="container-pefai-cards personal-data-card">
      <v-row class="padding-pefai">
        <v-col cols="12">
          <span class="text-title-card"> Datos personales </span>
        </v-col>
      </v-row>
      <v-row class="padding-pefai">
        <v-col cols="3">
          <v-text-field
            label="Nombre"
            outlined
            v-model="data.nombre"
            color="#00a7e4"
            type="text"
            :rules="requiredRule"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            label="Apellido paterno"
            outlined
            v-model="data.apellidoPaterno"
            color="#00a7e4"
            type="text"
            :rules="requiredRule"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            label="Apellido materno"
            outlined
            v-model="data.apellidoMaterno"
            color="#00a7e4"
            type="text"
            :rules="requiredRule"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="data.fechaNacimiento"
            label="Fecha de Nacimiento"
            outlined
            color="#00a7e4"
            type="date"
            :rules="requiredRule"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            label="Codigo Postal"
            color="#00a7e4"
            placeholder="#####"
            v-mask="'#####'"
            outlined
            v-model="data.codigoPostal"
            :rules="requiredRule"
            :error="cpError"
            :error-messages="cpErrorMessage"
          >
          </v-text-field>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { getAddressDataByCPExternal } from "@/services/codigoPostal/cp-external.service";

export default {
  data() {
    return {
      data: {
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        fechaNacimiento: "",
        codigoPostal: "",
      },
      cpError: false,
      cpErrorMessage: "",
      requiredRule: [(v) => !!v || "El campo es requerido"],
    };
  },
  props: {
    getInfo: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    async "data.codigoPostal"(val) {
      if (val.length === 5) {
        const response = await getAddressDataByCPExternal(val);
        if (response.error) {
          this.cpError = true;
          this.cpErrorMessage =
            response.error.message || "No existe el codigo postal.";
          this.$emit("fetchValidZip", false);
          return;
        }
        this.cpError = false;
        this.cpErrorMessage = "";
        this.$emit("fetchValidZip", true);
      }
    },
    getInfo(val) {
      if (val) {
        this.$emit("updatePersonalData", this.data);
      }
    },
  },
};
</script>

<style scoped>
.personal-data-full-width,
.personal-data-card {
  width: 100%;
  max-width: 100%;
}
</style>
